<template>
  <div class="grid">
    <div class="col-12">
      <Card>
        <template #title>Matrículas</template>
        <template #content>
          <DataTable
            stripedRows
            :value="matriculas"
            :loading="loading"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} matriculas"
            responsiveLayout="scroll">
            <template #empty> Nenhuma matrícula encontrada. </template>
            <template #loading> Carregando. Por favor aguarde. </template>
            <Column field="cpf" header="CPF"></Column>
            <Column field="nome" header="Nome"></Column>
            <Column field="matricula" header="Matrícula"></Column>
            <Column field="entidadeNome" header="Entidade"></Column>
            <Column field="vinculoNome" header="Vínculo"></Column>
            <Column header="Situação">
              <template #body="{ data }">
                <Tag
                  v-tooltip.bottom="
                    data.validacao.servidorApto
                      ? 'O servidor está apto a consignar.'
                      : 'O servidor está inapto a consignar pelo motivo(s): ' +
                        exibirMotivosInapto(data.validacao.motivos)
                  "
                  :value="
                    data.validacao.servidorApto
                      ? 'Apto a consignar'
                      : 'Inapto a consignar: ' +
                        exibirMotivosInapto(data.validacao.motivos)
                  "
                  :severity="data.validacao.severity">
                </Tag>
              </template>
            </Column>
            <Column header="Ações">
              <template #body="slotProps">
                <Button
                  v-tooltip.left="'Detalhes'"
                  class="p-button-rounded"
                  :icon="loadingDetail ? 'pi pi-spin pi-spinner' : 'pi pi-eye'"
                  @click="detalheServidor(slotProps.data)">
                </Button>
              </template>
            </Column>
          </DataTable>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import MatriculaService from '@/service/MatriculaService.js'

export default {
  data() {
    return {
      matriculas: [],
      matricula: {},
      deleteServidorDialog: false,
      loading: false,
      totalRecords: 0,
      lazyParams: {},
      loadingDetail: false,
    }
  },

  computed: {
    rowsPerPageOptions() {
      if (this.totalRecords < 5) {
        return null
      }
      return [5, 10, 25]
    },
  },

  created() {
    this.matriculaService = new MatriculaService(this.$http)
  },

  mounted() {
    this.loading = true
    this.carregarDados()
  },

  methods: {
    carregarDados() {
      this.loading = true
      this.matriculaService
        .getMatriculasUsuarioLogado()
        .then((res) => {
          this.matriculas = res
          this.limpar()
        })
        .catch((err) => {
          const mensagem = err.response
            ? err.response.data.message
            : 'Erro de conexão com a aplicação.'
          this.limpar()
          this.$toast.add({
            severity: 'error',
            summary: mensagem,
            life: 10000,
          })
          this.$router.push('/logout')
        })
    },

    limpar() {
      this.loading = false
    },

    detalheServidor(data) {
      this.loadingDetail = true
      this.$router.push({ name: 'margem', params: { id: data.id } })
      this.loadingDetail = false
    },

    exibirMotivosInapto(arrayMotivos) {
      return arrayMotivos.length > 1 ? arrayMotivos[1] : arrayMotivos[0]
    },
  },
}
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}
</style>
